import React from 'react';
import { BadgeCheckIcon, PencilIcon, SigmaIcon, SparklesIcon } from 'lucide-react';
import { Badge } from '../ui/Badge';
import type { Provenance } from '../../types/admissions';
const CONFIG: Record<Provenance, {
  label: string;
  tone: 'ok' | 'neutral' | 'brand' | 'warn';
  icon: React.ReactNode;
}> = {
  verified: {
    label: 'Verified by institution',
    tone: 'ok',
    icon: <BadgeCheckIcon className="h-3.5 w-3.5" data-id="element-5493" data-mp="1mlwewe51deyx" />
  },
  user: {
    label: 'Entered by you',
    tone: 'neutral',
    icon: <PencilIcon className="h-3.5 w-3.5" data-id="element-5494" data-mp="1rd4oba6d90c3" />
  },
  derived: {
    label: 'Derived from platform data',
    tone: 'brand',
    icon: <SigmaIcon className="h-3.5 w-3.5" data-id="element-5495" data-mp="1cp1hxzoevmmr" />
  },
  ai: {
    label: 'AI generated — check the source',
    tone: 'warn',
    icon: <SparklesIcon className="h-3.5 w-3.5" data-id="element-5496" data-mp="1hkqo4luxs1s1" />
  }
};
export function ProvenanceBadge({
  provenance,
  short = false
}: {
  provenance: Provenance;
  short?: boolean;
}) {
  const config = CONFIG[provenance];
  const shortLabels: Record<Provenance, string> = {
    verified: 'Verified',
    user: 'User entered',
    derived: 'Derived',
    ai: 'AI generated'
  };
  return <Badge tone={config.tone} icon={config.icon} data-id="element-5497" data-mp="10blim0p3v4ik">
      {short ? shortLabels[provenance] : config.label}
    </Badge>;
}